<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="サイズグループマスタ"
          icon="dashboard"
          class="masterSizeGroup-header" />
      <span class="action_button">
        <div class="edit-button-wrap">
          <el-dropdown
              v-show="showActionButtonComponent"
              @command="actionCommand">
            <el-button size="small">
              アクション
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu
                slot="dropdown"
                class="header-action-menu">
              <el-dropdown-item
                  :disabled="$isFunctionDisabled(define.PermissionKeys.Master.SizeGroup.EDIT)"
                  :command="define.PRODUCT_SIZE_MODE.EDIT">
                編集
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <BaseButton v-show="showEditButton"
              @click="cancel()">
            キャンセル
          </BaseButton>
          <BaseButton v-show="showEditButton"
              :disabled="disableSaveButton"
              @click="save()">
            保存
          </BaseButton>
        </div>
      </span>
    </el-row>
    <BaseSearchConditionModal
        v-if="true"
        :no-condition="false"
        :keyword="searchKeyword"
        :is-and-search="isAndSearch"
        :conditions="searchConditions"
        :base-query="baseQuery"
        :store-path="storePath"
        :res-path="responsePath"
        :save-key="saveKey"
        @search="onSearch"
        @searched="onSearched" />
    <div class="base-table-list tab-list div-flex row-clickable-table">
      <div class="width-50">
        <el-row class="add-row">
          <BaseButton v-show="showEditButton"
              @click="addRow('group')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table el-table--enable-row-hover">
          <div class="el-table__body-wrapper table_group">
            <table
                ref="table_group"
                class="table">
              <thead>
                <tr class="header">
                  <th class="is-leaf is-sortable width-30">サイズグループコード</th>
                  <th class="is-leaf is-sortable width-70">サイズグループ名</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(val, index) in sizeGroupList">
                  <tr :key="index"
                      :data-id="`${index}`"
                      class="el-table__row"
                      :class="{'moveable': mode === define.PRODUCT_SIZE_MODE.EDIT,
                               'hidRow': val.node.isActive !== 1,
                               'tr-size': selectIndex === index}"
                      @click="onClick(index)">
                    <td>
                      <BaseCell
                          :ref="`code_${index}`"
                          :properties="createTextAreaProp('code')"
                          :display-item="val.node"
                          :editable="val.node.id === ''" />
                    </td>
                    <td>
                      <div class="div-flex">
                        <BaseCell
                            :ref="`name_${index}`"
                            :properties="createTextAreaProp('name')"
                            :display-item="val.node"
                            class="width-50"
                            :editable="mode === define.PRODUCT_SIZE_MODE.EDIT
                              && !groupUsed(val.node)" />
                        <BaseCell
                            v-if="mode === define.PRODUCT_SIZE_MODE.EDIT
                              && groupUsed(val.node)"
                            :ref="`name_${index}`"
                            class="cell-msg"
                            :properties="createTextAreaProp('used')"
                            :display-item="val.node"
                            :editable="false" />
                        <BaseOperationTooltip
                            v-if="showTooltip && !groupUsed(val.node) && !groupItemUsed(val.node)"
                            :list="getTooltipList(index, 'group')"
                            placement="bottom-end" />
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tr v-if="sizeGroupList.length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="width-49">
        <el-row class="add-row">
          <BaseButton v-show="showEditButton"
              @click="addRow('size')">
            行追加
          </BaseButton>
        </el-row>
        <div class="el-table">
          <div class="el-table__body-wrapper table_size">
            <table
                ref="table_size"
                class="table">
              <thead>
                <tr class="header">
                  <th class="is-leaf is-sortable width-30">サイズコード</th>
                  <th class="is-leaf is-sortable width-70">サイズ名</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="sizeGroupList[selectIndex]">
                  <template v-for="(val, index) in sizeGroupList[selectIndex].node.sizeGroupItems">
                    <tr :key="index"
                        :data-id="`${index}`"
                        :class="{'moveable': mode === define.PRODUCT_SIZE_MODE.EDIT,
                                 'hidRow': val.isActive !== 1}">
                      <td>
                        <BaseCell
                            :ref="`code_${index}`"
                            :properties="createTextAreaProp('sizeCode')"
                            :display-item="val"
                            :editable="mode === define.PRODUCT_SIZE_MODE.EDIT
                              && (!sizeUsed(val) || !groupUsed(sizeGroupList[selectIndex].node))"
                            @change="(after) => onChange(after, index)" />
                      </td>
                      <td>
                        <div class="div-flex">
                          <BaseCell
                              :ref="`name_${index}`"
                              :properties="createTextAreaProp('sizeName')"
                              :display-item="val"
                              class="width-50"
                              :class="{'sizeCode-adjustment': mode === define.PRODUCT_SIZE_MODE.EDIT
                                && (!sizeUsed(val) || !groupUsed(sizeGroupList[selectIndex].node)) }"
                              :editable="mode === define.PRODUCT_SIZE_MODE.EDIT
                                && (!sizeUsed(val) || !groupUsed(sizeGroupList[selectIndex].node))" />
                          <BaseCell
                              v-if="mode === define.PRODUCT_SIZE_MODE.EDIT
                                && (sizeUsed(val) && groupUsed(sizeGroupList[selectIndex].node))"
                              :ref="`name_${index}`"
                              class="cell-msg"
                              :properties="createTextAreaProp('itemused')"
                              :display-item="val.node"
                              :editable="false" />
                          <BaseOperationTooltip
                              v-if="showTooltip && (!sizeUsed(val) || !groupUsed(sizeGroupList[selectIndex].node))"
                              :list="getTooltipList(index, 'size')"
                              placement="bottom-end" />
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
              </tbody>
              <tr v-if="!sizeGroupList[selectIndex] || sizeGroupList[selectIndex].node.sizeGroupItems.length < 1">
                <td colspan="3"
                    class="td-empty">
                  データなし
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .add-row {
    text-align: right;
    height: 35px;
  }
  .tab-list {
    padding-top: 0px !important;
  }
  .table {
    width: 100%;
  }
  .th-bottom {
    border-bottom: 1px solid #ebeef5;
  }
  .moveable {
  cursor: pointer;
  }
  .hidRow {
  display: none;
  }
  .td-empty {
    text-align: center !important;
    color: #909399 !important;
  }
  .div-flex {
    display: flex;
    justify-content: space-between;
  }
  .sizeCode-adjustment {
    margin-top :-2px;
  }
  .cell-msg {
    color: #e22908;
    text-align: right;
    margin-right: 10px;
  }
  .width-30 {
    width: 30%;
  }
  .width-50 {
    width: 50%;
  }
  .width-49 {
    width: 49%;
  }
  .width-70 {
    width: 70%;
  }
  .tr-size {
    background-color: #fcfbed !important;
  }
</style>
<script>
import _ from 'lodash'
import Sortable from 'sortablejs'
import { mapState, mapGetters } from 'vuex'

import * as define from '@/define'
import * as query from '@/queries/master'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import BaseCell, { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseOperationTooltip from '@/components/molecules/BaseOperationTooltip'
import BaseSearchConditionModal from '@/components/organisms/BaseSearchConditionModal'
import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import detailUtil from '@/components/mixins/detailUtil'

const sizeValidationRules = (v) => {
  // サイズグループコードの重複チェック
  v.$validator.extend('groupCodeDuplicateCheck', {
    getMessage: () => '同じサイズグループコードが存在します',
    validate: (data) => {
      // 該当サイズグループコードはリストに既存の場合、エラーになる
      if (v.sizeGroupList.filter((val, key) => { return val.node.code.toUpperCase() === data.toUpperCase() }).length > 1) {
        return false
      }
      return true
    }
  })
  // サイズグループコードの重複チェック
  v.$validator.extend('sizeCodeDuplicateCheck', {
    getMessage: () => '同じサイズコードが存在します',
    validate: (data) => {
      // 該当サイズコードはリストに既存の場合、エラーになる
      if (v.sizeGroupList[v.selectIndex].node.sizeGroupItems.filter((val, key) => { return val.code.toUpperCase() === data.toUpperCase() }).length > 1) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'MasterSizeGroupList',
  components: {
    BaseHeader,
    BaseCell,
    BaseButton,
    BaseSearchConditionModal,
    BaseOperationTooltip
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      isChanged: false,
      selectIndex: 0,
      sizeGroupList: [],
      originSizeGroupList: [],
      sizeNameList: [],
      sortGroupAble: Object,
      sortSizeAble: Object
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      mode: (state) => state.MasterSizeGroup.mode,
      searchKeyword: (state) => state.MasterSizeGroup.searchKeyword,
      isAndSearch: (state) => state.MasterSizeGroup.isAndSearch,
      searchConditions: (state) => state.MasterSizeGroup.searchConditions,
      tdLists: (state) => state.MasterSizeGroup.tdLists
    }),
    ...mapGetters({
    }),
    saveKey () {
      return 'masterSizeCondition'
    },
    storePath () {
      return 'MasterSizeGroup'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_PRODUCT_SIZEGROUP_LIST
    },
    responsePath () {
      return 'data.sizeGroupListItems.edges'
    },
    showActionButtonComponent () {
      return (this.showActionButton && (this.$isFunctionShown(define.PermissionKeys.Master.SizeGroup.EDIT)))
    },
    showTooltip () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    },
    showActionButton () {
      return this.mode === define.PRODUCT_SIZE_MODE.NORMAL
    },
    showEditButton () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    editableValidIds () {
      return this.mode !== define.PRODUCT_SIZE_MODE.NORMAL
    }
  },
  watch: {
    sizeGroupList: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode: {
      handler: function (val, oldVal) {
        if (oldVal != null) {
          // 通常モード ==> 編集モードの場合
          if (val === define.PRODUCT_SIZE_MODE.EDIT) {
            // 編集モードに切り替える場合
            this.originSizeGroupList = _.cloneDeep(this.sizeGroupList)
            // ソート出来るグループTABLEを設定する
            this.createGroupSortTable()
            // ソート出来るサイズTABLEを設定する
            this.createSizeSortTable()
            this.$_ConfirmDiscardOnLeave_watchStart(this.sizeGroupList)
          } else {
            // 編集モード ==> 通常モードの場合
            this.selectIndex = 0
            if (this.sortGroupAble) {
              // 通常モードに切り替える場合
              this.sortGroupAble.sort(this.sortGroupAble.toArray().map(Number).sort((a, b) => a - b))
              // ソート出来るTABLEを削除
              this.sortGroupAble.destroy()
            }
            if (this.sortGroupAble) {
              // 通常モードに切り替える場合
              this.sortSizeAble.sort(this.sortSizeAble.toArray().map(Number).sort((a, b) => a - b))
              // ソート出来るTABLEを削除
              this.sortSizeAble.destroy()
            }
            this.$_ConfirmDiscardOnLeave_watchEnd()
          }
        }
      },
      deep: true
    }
  },
  async created () {
    this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
    // 画面初期化する時に、一覧リストを取得する
    await this.getDetailData()

    await this.getSizeMaster()
    // カスタムバリデーションルールを追加
    sizeValidationRules(this)
  },
  mounted () {
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    onChange (event, index) {
      const checkName = this.sizeNameList.find((element) => element.code === event)
      if (checkName != null) {
        this.sizeGroupList[this.selectIndex].node.sizeGroupItems[index].name = checkName.name
      }
    },

    /**
     * 行クリック
     */
    async onClick (index) {
      // チェック処理（選択する前に既存のデータをチェックする）
      if (!await this.$validator.validate()) {
        return
      }
      // 行選択を設定
      this.selectIndex = index
      // フォーカス移動
      window.scroll({ top: this.$refs['table_size'].offsetTop, behavior: 'smooth' })
    },
    /**
     * グループドラッグTableを作成
     */
    createGroupSortTable (oldIndex, newIndex) {
      // ソート対象テーブルを取得する
      const tbody = document.querySelector('.table_group tbody')
      if (tbody == null) {
        return
      }
      // ソートテーブルを生成
      this.sortGroupAble = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        disabled: false,
        onEnd: evt => {
          // ソートした後、サイズリストのINDEXを再計算する
          this.sortGroupIndex(this.sortGroupAble.toArray())
        }
      })
    },
    /**
     * ドラッグした場合、グループリストにのソートを再計算する.
     */
    sortGroupIndex (sortOrder) {
      for (let i = 0; i < this.sizeGroupList.length; i++) {
        const index = sortOrder.map(Number).indexOf(i)
        this.sizeGroupList[i].node.displayOrder = index + 1
      }
    },
    /**
     * サイズドラッグTableを作成
     */
    createSizeSortTable (oldIndex, newIndex) {
      // ソート対象テーブルを取得する
      const tbody = document.querySelector('.table_size tbody')
      if (tbody == null) {
        return
      }
      // ソートテーブルを生成
      this.sortSizeAble = Sortable.create(tbody, {
        animation: 180,
        delay: 0,
        disabled: false,
        onEnd: evt => {
          // ソートした後、サイズリストのINDEXを再計算する
          this.sortSizeIndex(this.sortSizeAble.toArray())
        }
      })
    },
    /**
     * ドラッグした場合、サイズリストにのソートを再計算する.
     */
    sortSizeIndex (sortOrder) {
      for (let i = 0; i < this.sizeGroupList[this.selectIndex].node.sizeGroupItems.length; i++) {
        const index = sortOrder.map(Number).indexOf(i)
        this.sizeGroupList[this.selectIndex].node.sizeGroupItems[i].displayOrder = index + 1
      }
    },
    onSearch (keyword, conditions) {
      this.$emit('search', keyword, conditions)
    },
    onSearched (result) {
      // 検索後、データを再取得、通常モードに戻る
      this.$emit('searched', result)
      this.sizeGroupList = this.tdLists
      // ディフォルト行選択に０を設定
      this.selectIndex = 0
      // 再検索後、通常モードに切り替える
      this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
    },
    /**
     * productマスタに使用中かをチェックする.
     */
    groupUsed (node) {
      // productマスタにサイズグループコードに紐づくレコードがある場合、使用中とみなす
      return node.productExists
    },

    /**
     * skuマスタに使用中かをチェックする.
     */
    sizeUsed (node) {
      // skuマスタにサイズグループコードに紐づくレコードがある場合、使用中とみなす
      return node.skuExists
    },

    groupItemUsed (node) {
      // サイズグループ詳細にレコードがある場合、使用中とみなす
      return node.sizeGroupItems.length > 0
    },

    /**
     * 画面一覧項目を生成.
     * @param {Object} path 項目キー
     */
    createTextAreaProp (path) {
      // サイズグループコード
      if (path === 'code') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'required|max:50|groupCodeDuplicateCheck', validateAs: 'サイズグループコード'
        }
      }
      // サイズグループ名
      if (path === 'name') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: path, validateRule: 'max:256', validateAs: 'サイズグループ名'
        }
      }
      // サイズコード
      if (path === 'sizeCode') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX,
          path: 'code', validateRule: 'required|max:50|sizeCodeDuplicateCheck', validateAs: 'サイズコード',
          selectCode: () => _.map(this.sizeNameList, val => ({ code: val.code, name: val.code })),
          codeName: (code) => {
            return (this.sizeNameList.find(element => code === element.code) || {}).code
          }
        }
      }
      // サイズ名
      if (path === 'sizeName') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.INPUT,
          path: 'name', validateRule: 'max:256', validateAs: 'サイズ名'
        }
      }
      // 使用中文字
      if (path === 'used') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT,
          path: '商品マスタに利用されています', class: { bold: true, center: true }
        }
      }
      // 使用中文字
      if (path === 'itemused') {
        return {
          type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT,
          path: 'SKUマスタに利用されています', class: { bold: true, center: true }
        }
      }
    },
    /**
     * グループTooltipの項目を返却する.
     * @param {Object} row 注文情報
     * @return {Array}
     */
    getTooltipList (index, type) {
      return [
        {
          title: '削除',
          click: () => this.delete(index, type)
        }
      ]
    },
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.PRODUCT_SIZE_MODE.EDIT:
          this.editSize()
          break
        default: {}
      }
    },

    /**
     * EDIT処理
     */
    async editSize () {
      // 編集モードは全検索は前提です
      if (this.searchKeyword !== '') {
        // 検索条件がある場合、確認メッセージを出す
        this.$confirm('編集モードでは全件表示されます', define.MESSAGE_TITLE, {
          confirmButtonText: 'OK',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(async () => {
          // OKの場合、検索条件をクリアして、再検索を行う
          await this.updateStore('searchKeyword', '')
          await this.updateStore('isAndSearch', false)
          // 再検索を行う
          await this.getDetailData()
          await this.getSizeMaster()
          // 編集モードに切り替える
          this.updateStore('mode', define.PRODUCT_SIZE_MODE.EDIT)
        }).catch(() => {
          this.$notify.info('キャンセルしました。')
        })
      } else {
        // そもそもが全検索の場合、そのまま編集モードに切り替える
        this.updateStore('mode', define.PRODUCT_SIZE_MODE.EDIT)
      }
    },
    /**
     * 新規サイズグループ行を生成.
     */
    addRow (type) {
      if (type === 'group') {
        // グループ行追加の場合
        this.sizeGroupList.push({ node: { id: '', isActive: 1, displayOrder: '', code: '', name: '', sizeGroupItems: [], productExists: 0 } })
        // 追加した行を選択
        this.onClick(this.sizeGroupList.length - 1)
        // フォーカス移動
        window.scroll({ top: this.$refs['table_group'].offsetHeight, behavior: 'smooth' })
      } else {
        // サイズ行追加の場合
        this.sizeGroupList[this.selectIndex].node.sizeGroupItems.push({ id: '', isActive: 1, displayOrder: '', code: '', name: '', skuExists: 0 })
        // フォーカス移動
        window.scroll({ top: this.$refs['table_size'].offsetHeight, behavior: 'smooth' })
      }
    },
    /**
     * グループ削除を行う
     * @param {Number} index インデックス
     */
    delete (index, type) {
      if (type === 'group') {
        // グループ行を削除する場合
        if (this.sizeGroupList[index].node.id === '') {
          // 追加行の場合、そのまま削除する
          this.sizeGroupList.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.sizeGroupList[index].node.isActive = 0
        }
      } else {
        // サイズ行を削除する場合
        if (this.sizeGroupList[this.selectIndex].node.sizeGroupItems[index].id === '') {
          // 追加行の場合、そのまま削除する
          this.sizeGroupList[this.selectIndex].node.sizeGroupItems.splice(index, 1)
        } else {
          // 既存行の場合、削除フラグに０を更新する
          this.sizeGroupList[this.selectIndex].node.sizeGroupItems[index].isActive = 0
        }
      }
    },
    /**
     * サイズグループ編集保存を行う
     */
    async save () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      // 保存を行う
      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          // サイズ編集パラメータの作成
          const data = this.buildRequestForUpdate()
          // サイズ編集保存を行う
          await this.updateSizeGroupApi(data)
          this.isChanged = false
          // 編集保存後、通常モードに切り替える
          this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
          // 保存後、リスト再検索を行う
          await this.getDetailData()
          await this.getSizeMaster()
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            // システムエラー
            common.addError(error, { msg: message.MSG_502() })
          } else {
            // APIエラー
            common.addError(error, { msg: message.MSG_546() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    /**
     * サイズ編集キャンセルを行う
     */
    async cancel () {
      const cancelEdit = () => {
        // 通常モードに切り替える
        this.updateStore('mode', define.PRODUCT_SIZE_MODE.NORMAL)
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm('サイズグループ変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        // キャンセル後、リスト再検索を行う
        this.getDetailData()
        this.getSizeMaster()
        cancelEdit()
      }).catch(() => {
      })
    },
    /**
     * サイズグループ情報を取得する。
     */
    async getDetailData () {
      try {
        this.$loadingService.show()
        // 検索SQLを作成する
        const queryQL = common.addGraphQlCondition(query.GRAPH_QL_QUERY_PRODUCT_SIZEGROUP_LIST, { keyword: this.searchKeyword })
        // サイズ検索APIを呼び出す
        const res = await common.postGraphQl(queryQL)
        // DBから画面の情報を取得
        this.sizeGroupList = res.data.data.sizeGroupListItems.edges
        this.originSizeGroupList = _.cloneDeep(this.sizeGroupList)
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    async getSizeMaster () {
      let res = await common.postGraphQl(query.GRAPH_QL_QUERY_SIZE_MASTER, { isMessageControl: true })
      this.sizeNameList = res.data.data.sizes
    },

    /**
     * 一覧 からサイズ更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      let requestData = []
      // 差分レコードを取得
      const diffList = compare.diff(this.originSizeGroupList, this.sizeGroupList)
      for (const index in diffList) {
        const groupItem = this.sizeGroupList[index].node
        // サイズ情報の生成
        const sizeGroupItems = []
        for (const itemIndex in diffList[index].node.sizeGroupItems) {
          const sizeItem = groupItem.sizeGroupItems[itemIndex]
          sizeGroupItems.push(
            {
              itemIndex: sizeItem.displayOrder, // サイズコード
              itemUuid: sizeItem.uuid, // uuid
              itemCode: sizeItem.code, // サイズ名
              itemName: sizeItem.name, // サイズ表示順
              delete: sizeItem.isActive === 0 ? 1 : 0 // 有効フラグ（有効）
            })
        }
        // グループ情報を生成
        requestData.push(
          {
            groupCode: groupItem.code, // グループコード
            groupName: groupItem.name, // グループ名
            groupIndex: groupItem.displayOrder, // グループ表示順
            delete: groupItem.isActive === 0 ? 1 : 0, // 有効フラグ（有効）
            sizeGroupItems: sizeGroupItems
          })
      }
      return requestData
    },
    /**
     * サイズ更新 APIを呼び出す
     */
    async updateSizeGroupApi (requestData) {
      const data = {
        sizeGroups: requestData
      }
      const url = config.PRODUCT_SIZEGROUP_URL
      const method = 'post'
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    /**
     * ストアの情報を更新する
     */
    updateStore (key, val) {
      const storeKey = `MasterSizeGroup/${key}`
      this.$store.commit({
        type: 'set',
        states: {
          [storeKey]: val
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/master/MasterSizeGroupTop.vue